import Banner from './Banner';
import ProductTiles from './ProductTiles';
import BenefitsList from '@/components/Static/BenefitCard';
import HeroBanner from '@/components/Static/HeroBanner';

import Title from '@/components/Static/Title';
import VideoCard from '@/components/Static/VideoCard';
import AppDownloadCard from './AppDownloadCard';
import { MemoExoticComponent } from 'react';
import { CMS_COMPONENTS } from '@/constants/cms';

const STATIC_MAP: { [key: string]: MemoExoticComponent<any> | any } = {
  [CMS_COMPONENTS.SHARED.BANNER]: Banner,
  'shared.fg-product-tiles': ProductTiles,
  [CMS_COMPONENTS.STATIC.BENEFIT_CARD]: BenefitsList,
  [CMS_COMPONENTS.SHARED.HERO_BANNER]: HeroBanner,
  [CMS_COMPONENTS.SHARED.TITLE]: Title,
  [CMS_COMPONENTS.SHARED.VIDEO_CARD]: VideoCard,
  [CMS_COMPONENTS.SHARED.APP_DOWNLOAD_CARD]: AppDownloadCard,
};

export default STATIC_MAP;
